import { jsx as r } from "react/jsx-runtime";
import { useRef as G } from "react";
import O from "react-select";
import k from "./CustomComponents.js";
import q from "./hooks/useCustomStyles.js";
import x from "./hooks/useGetMultiSelectProps.js";
function H({
  name: l,
  options: f,
  value: m,
  onChange: n,
  isSearchable: c = !1,
  isClearable: p = !1,
  isDisabled: e = !1,
  closeMenuOnSelect: i = !1,
  hideSelectedOptions: u = !1,
  backspaceRemovesValue: a = !1,
  renderNoOptionsMessage: S,
  fixedValues: t = [],
  listHeader: y = "",
  withSelectAll: M = !1,
  dataNoTranslateOption: d,
  dataNoTranslateListHeader: P,
  ariaLabel: R,
  maxMultiValueLabels: o = 5,
  disableAllSelected: g = !1,
  onMenuOpen: h,
  onMenuClose: j,
  ...v
}) {
  const w = q(), s = G(null), C = x({
    options: f,
    value: m,
    onChange: n,
    withSelectAll: M,
    isDisabled: e,
    fixedValues: t,
    multiSelectRef: s,
    maxMultiValueLabels: o,
    disableAllSelected: g,
    onMenuOpen: h,
    onMenuClose: j
  });
  return /* @__PURE__ */ r("div", { ref: s, children: /* @__PURE__ */ r(
    O,
    {
      ...v,
      ...C,
      name: l,
      isMulti: !0,
      styles: w,
      closeMenuOnSelect: i,
      hideSelectedOptions: u,
      backspaceRemovesValue: a,
      isSearchable: c,
      isClearable: p,
      isDisabled: e,
      noOptionsMessage: S,
      components: k,
      dataNoTranslateOption: d,
      dataNoTranslateListHeader: P,
      listHeader: y,
      fixedValues: t,
      ariaLabel: R,
      maxMultiValueLabels: o
    }
  ) });
}
export {
  H as default
};
